<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <mat-label>{{ 'Tipo operazione' | translate }}</mat-label>
    <mat-select formControlName="type">
      <mat-option></mat-option>
      <mat-option
        *ngFor="let type of iterableAuditTypeLabels"
        [value]="type.value">
        {{ type.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'Tipo oggetto' | translate }}</mat-label>
    <mat-select formControlName="className">
      <mat-option></mat-option>
      <mat-option
        *ngFor="let type of iterableAuditClassNameLabels"
        [value]="type.value">
        {{ type.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'Dal' | translate }}</mat-label>
    <input
      matInput
      formControlName="date"
      [matDatepicker]="datePicker">
    <mat-datepicker-toggle
      matSuffix
      [for]="datePicker">
    </mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'Resource Id' | translate }}</mat-label>
    <input
      matInput
      formControlName="objectId">
  </mat-form-field>
</form>
